import { render, staticRenderFns } from "./StandardCourseManagement.vue?vue&type=template&id=58c81288&scoped=true"
import script from "./StandardCourseManagement.vue?vue&type=script&lang=js"
export * from "./StandardCourseManagement.vue?vue&type=script&lang=js"
import style0 from "./StandardCourseManagement.vue?vue&type=style&index=0&id=58c81288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c81288",
  null
  
)

export default component.exports